import React, { useEffect } from 'react';
import TopBar from '../../Components/TopBar';
import Footer from '../../Components/Footer';
import { pageView } from '../../Utilities/GoogleAnalytics';
import OutlineButton from '../../Components/OutlineButton';

export default function About() {
  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
    window.scroll(0, 0);
  }, []);

  const TitleSection = () => {
    return (
      <>
        <div className="flex flex-col-reverse items-center h-auto pt-20 bg-altBack lg:flex-row lg:pt-32">
          <div className="w-full text-center md:p-6 lg:p-0">
            <div className="w-full p-6 m-auto my-6 bg-white shadow-sm md:p-16 lg:p-24 lg:w-9/12">
              <h1 className="my-6 text-3xl font-bold text-brandcolor font-brand lg:text-4xl">We’re on a mission to enable students.</h1>
              <p className="w-full text-left text-gray-700 text-md lg:text-xl font-brand">
                Applying to study in Canada is a straightforward process that is monetized beyond measure. While there is authentic advice out there,
                a fair percentage of this space is teeming with outright fraud.
                <br />
                <br />
                At Stamped, we've resolved to make a change. To create a functional and enriching solution for every student. To put value before
                business, and to make lives easier. In order to achieve this, we have created extremely useful tools and an all-encompassing bundle
                with ready-to-edit files, folders, checklists, and step-by-step processes. Our tools assist your selection and planning, while the
                bundle enables your understanding of the actual process. Our tools are presently free for all students.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Heading = () => (
    <div className="h-auto pb-12 text-center bg-altBack">
      <div className="flex items-center justify-center pt-24 pb-12 ml-12 mr-12 lg:mr-0 lg:ml-0 lg:pt-16 lg:pb-16 font-brand">
        <div className="w-full lg:w-1/2">
          <h3 className="text-2xl font-bold text-center text-gray-800 lg:text-3xl">
            Get 10 times the value of a consultancy at 1/10th the price. Save time and money. Get Stamped.
          </h3>
          <div className="my-6">
            <OutlineButton text={'See what students are saying'} url={'/reviews'} />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-altBack">
      <TopBar />
      <TitleSection />
      <Heading />
      <Footer />
    </div>
  );
}
